import moment from 'moment'
import React from 'react'

interface TermsOfUseProps {
  companyName: string
  firstName: string
  isCompany: boolean
  lastName: string
}

const TermsOfUse = ({ companyName, firstName, isCompany, lastName }: TermsOfUseProps) => {
  const today = moment().format('MM/DD/YYYY')

  const label = !isCompany ? `${firstName} ${lastName} ${today}` : `${companyName} ${today}`

  return (
    <div className="text-grey text-sm my-8">
      <p>
        I agree to accept the terms of{' '}
        <a href="https://paro.io/talent-terms-of-use/" target="_blank" rel="noopener noreferrer">
          <span className="text-link">this agreement</span>
        </a>
        , and understand that it contains an Arbitration Agreement, including a class and collective action waiver. By
        clicking my acceptance, I will be able to accept a SOW through Paro.
      </p>
      <span className="text-lg">{label}</span>
    </div>
  )
}

export default TermsOfUse
